// extracted by mini-css-extract-plugin
module.exports = {"root":"FullWidthCta_root__x4sIe","wrapper":"FullWidthCta_wrapper__21aE6","title":"FullWidthCta_title__hPgfI","ctaButton":"FullWidthCta_ctaButton__rE1Ht"};